import { useQuery } from "@apollo/client";
import gql from "graphql-tag";

import Context from "shared/util/Context";

const ONE_DAY_IN_SEC = 60 * 60 * 24;
const ONE_WEEK_IN_SEC = ONE_DAY_IN_SEC * 7;
const todayInSecs = () => Date.now() / 1000;

export const QUERY = gql`
	query webRateCardViews($userId: String!) {
		user(id: $userId) {
			id
			hasAListBasic: hasPremium(name: ALIST_BASIC)
			hasAListPremium: hasPremium(name: ALIST_PREMIUM)
			rateCardViews {
				upgradeToAlistPremiumPaywall {
					viewedCount
					maxViewsAllowed
					lastSeenTimestamp
				}
			}
		}
	}
`;

export function hasBeenOneDaySinceAListSub(currentSubscriptionPurchaseDate) {
	return (todayInSecs() - currentSubscriptionPurchaseDate) > ONE_DAY_IN_SEC;
}

export function useShouldShowUpgradeToPremium(
	isPathToUpgradeTest,
	currentSubscriptionPurchaseDate,
) {
	const { data } = useQuery(QUERY, {
		variables: {
			userId: Context.get("userid"),
		},
		skip: !isPathToUpgradeTest,
	});

	const rateCardViews = data?.user?.rateCardViews?.upgradeToAlistPremiumPaywall || {};

	if (!isPathToUpgradeTest
		|| !data?.user?.hasAListBasic
		|| data?.user?.hasAListPremium
		|| rateCardViews.viewedCount >= rateCardViews.maxViewsAllowed
	) return false;

	const hasBeenAtLeastADaySincePurchase =
		hasBeenOneDaySinceAListSub(currentSubscriptionPurchaseDate);

	if (rateCardViews.viewedCount < 1 && !hasBeenAtLeastADaySincePurchase) {
		return false;
	}

	const daysInSecsSinceLastSeen = todayInSecs() - rateCardViews.lastSeenTimestamp;

	if (daysInSecsSinceLastSeen < ONE_WEEK_IN_SEC) {
		return false;
	}

	return true;
}



// WEBPACK FOOTER //
// ./src/shared/hooks/useShouldShowUpgradeToPremium.js